var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_4724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1496 88.5539H3.97034C2.8584 88.5539 1.95703 87.6525 1.95703 86.5406V82.5138C1.95703 81.4019 2.8584 80.5005 3.97034 80.5005H96.0296C97.1416 80.5005 98.0429 81.4019 98.0429 82.5138V86.5406C98.0429 87.6525 97.1416 88.5539 96.0296 88.5539H58.8285",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.9999,
    cy: 88.5536,
    r: 1.95695,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0429 80.5004H11.1016V65.0253C11.1016 63.9292 11.9902 63.0405 13.0863 63.0405H29.0583C30.1544 63.0405 31.0429 63.929 31.0429 65.0253V80.5004Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9686 80.5004H40.0273V65.0253C40.0273 63.9292 40.9158 63.0405 42.0119 63.0405H57.9839C59.08 63.0405 59.9686 63.929 59.9686 65.0253V80.5004Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8983 80.5004H68.957V65.0253C68.957 63.9292 69.8455 63.0405 70.9418 63.0405H86.9138C88.0099 63.0405 88.8985 63.929 88.8985 65.0253V80.5004H88.8983Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.959 70.5654H59.9727",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1018 70.5652H3.91398C2.83374 70.5652 1.95703 69.6885 1.95703 68.6082V13.4027C1.95703 12.3225 2.83374 11.4458 3.91398 11.4458H96.0862C97.1664 11.4458 98.0431 12.3225 98.0431 13.4027V68.6082C98.0431 69.6885 97.1664 70.5652 96.0862 70.5652H88.8983",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0293 70.5654H31.043",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5165 37.2943C57.1714 38.2498 57.1714 40.6385 55.5165 41.5941L50.2646 44.6261L45.0127 47.6582C43.3578 48.6138 41.2891 47.4193 41.2891 45.5083V39.4442V33.3798C41.2891 31.4688 43.3578 30.2743 45.0127 31.2299L50.2646 34.262L55.5165 37.2943Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_4724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p4.6ed2457526cfdc290e785954f36e9cc0.svg";
export { ForwardRef as ReactComponent };